@if ((corporateTaxEntity$ | async)) {
  <form [formGroup]="omschrijvingBedragFg" (change)="saveForm()">
    <div formArrayName="omschrijvingBedrag">
      @for (item of omschrijvingBedrag.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="row mb-1">
            <div class="col-auto">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving' : ''"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
                                              id="omschrijving-' + i"
              >
              </snelstart-ui-text-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-number-form-control [label]="i === 0 ? 'Bedrag' : ''"
                                                [showAllDecimals]="false"
                                                align="right"
                                                class="custom-input-150" formControlName="bedrag"
                                                id="bedrag-' + i"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-button
                (click)="verwijderRij(i)"
                [class]="i === 0 ? 'firstrowbutton' : ''"
                icon="trash"
                iconType="light"
                id="buttonDelete-' + i"
                size="medium"
                type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" id="cancel"
                       type="link">Niet aftrekbare boete toevoegen
  </snelstart-ui-button>
}

